export default "__VITE_ASSET__1196e665__"